import { Component, Input, OnInit } from '@angular/core';
import { File, Measurement, User } from '@cosmos/shared';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FilesService } from '@cosmos/angular/api';
import { ActionDefinition, ColumnDefinition } from '../../data/data-table/column-definition.model';
import { MeasurementsService } from '@cosmos/angular/api';
import { RBACService, StateService } from '@cosmos/angular/utils';
import { DataTableComponent } from '../../data/data-table/data-table.component';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';

@Component({
  selector: 'cosmos-reports-manager',
  imports: [TranslatePipe,
    DataTableComponent, ButtonModule, DividerModule
  ],
  templateUrl: './reports-manager.component.html',
})
export class ReportsManagerComponent implements OnInit {

  @Input()
  measurement: Measurement;
  
  user: User;
  reportsList: File[];
  generatingReport = false;

  actions: ActionDefinition[] = [
    {name: 'download', label: 'table.actions.download', icon: 'download', sticky: true},
    {name: 'email', label: 'table.actions.email-send', icon: 'envelope', sticky: true},
  ];

  columns: ColumnDefinition[] = [
    {name: 'filename', label: 'table.labels.name', visible: true, sortable: true, draggable: true},
    {name: 'createdAt', label: 'table.labels.created-at', visible: true, sortable: true, draggable: true, type: "date"}
  ];

  constructor(
    private translateService: TranslateService,
    public rbac: RBACService,
    private filesService: FilesService,
    private measurementsService: MeasurementsService,
    private stateService: StateService,
  ) { }

  ngOnInit(): void {
    this.stateService.currentUser$.subscribe(x => {this.user = x;});

    this.getData();
  }

  getData() {
    this.filesService.find('?context=measurementReport&serviceId=' + this.measurement._id).subscribe({
      next: (response) => {
        this.reportsList = response.body;
      },
      error: (e) => {
        // ADD TOAST
        // this.snackBar.open(this.translateService.instant("measurement.download.error"),"OK")
      }
    });
  }

  downloadReport(fileObject) {
    this.filesService.getFile(fileObject.path, fileObject.filename, 'pdf').subscribe({
      next: (response) => {
        this.filesService.downloadFromBlob(response);
      },
      error: (e) => {
        // ADD TOAST
        // this.snackBar.open(this.translateService.instant("measurement.download.error"),"OK")
      }
    })
  }

  emailReport(fileObject) {
    this.filesService.sendFileByEmail(fileObject.path, fileObject.filename).subscribe({
      next: (response) => {
      },
      error: (e) => {
        // ADD TOAST
        // this.snackBar.open(this.translateService.instant("measurement.download.error"),"OK")
      }
    })
  }

  generateReport() {
    this.generatingReport = true;
    this.measurementsService.generateReport(this.measurement._id).subscribe({
      next: (response) => {
        this.measurement.report = response.headers.get('Content-Disposition').split('=')[1]
        this.filesService.downloadFromBlob(response);
        this.generatingReport = false;
        this.getData();
        // ADD TOAST
        // this.snackBar.open(this.translateService.instant("measurement.download.success"),"OK")
      },
      error: (e) => {
        // ADD TOAST
        // this.snackBar.open(this.translateService.instant("measurement.download.error"),"OK")
      }
    })
  }


  rowAction(event: any) {
    if(event.action ===  'download') {
      this.downloadReport(event.row);
    }
    else if(event.action === 'email') {
      this.emailReport(event.row);
    }
  }
}
